klevu.ready(function(){

  const typeOrder = [
    ["T-shirts et chemises","T-shirts et chemises || T-shirts and shirts"],
    ["Vestes et chandails","Vestes et chandails || Jackets and sweaters"],
    ["Pyjamas","Pyjamas || Pajamas"],
    ["Pantalons et leggings", "Pantalons et leggings || Pants and leggings"],
    ["Robes et jupes","Robes et jupes || Dresses and skirts"],
    ["Pantalons et shorts","Pantalons et shorts || Pants and shorts"],
    ["Cache-couches","Cache-couches || Bodysuits"],
    ["Habits de neige","Habits de neige || Snowsuits"],
    ["Accessoires","Accessoires || Accessories"],
    ["Polar","Polar || Polar"],
    ["Boxers - caleçons - camisoles","Boxers - caleçons - camisoles || Boxers - underpants - camisoles"],
    ["Manteaux et pantalons","Manteaux et pantalons || Coats and pants"],
    ["Tuques - foulards - mitaines","Tuques - foulards - mitaines || Tuques - scarves - mittens"],
    ["Bas","Bas || Socks"],
    ["Bas et collants","Bas et collants || Stockings and tights"],
    ["Autres accessoires","Autres accessoires || Other accessories"],
    ["Camisoles et culottes","Camisoles et culottes || Camisoles and panties"],
    ["Pantalons - leggings - shorts","Pantalons - leggings - shorts || Pants - leggings - shorts"],
    ["Chapeaux et bonnets","Chapeaux et bonnets || Hats and beanies"],
    ["Maillots de bain","Maillots de bain || Swimsuit"],
    ["T-shirts - vestes - chandails","T-shirts - vestes - chandails || T-shirts - jackets - sweaters"],
    ["Sacs","Sacs || Bags"],
    ["Décoration","Décoration || Decoration"],
    ["Literie","Literie || Bedding"],
    ["Sous-vêtements","Sous-vêtements || Underwear"],
    ["Pantalons et salopettes","Pantalons et salopettes || Pants and overalls"],
    ["Cosmétiques et soins","Cosmétiques et soins || Cosmetics and care"],
    ["Pantalons - salopettes - shorts","Pantalons - salopettes - shorts || Trousers - overalls - shorts"],
    ["Une-pièces et salopettes","Une-pièces et salopettes || One-pieces and overalls"],
    ["Bavoirs","Bavoirs || bibs"],
    ["Cache-couches - t-shirts - chemises","Cache-couches - t-shirts - chemises || Bodysuits - t-shirts - shirts"],
    ["Camisoles","Camisoles || Camisoles"],
    ["ROBE","Robe || Dress"],
    ["Cartes-cadeaux","Cartes-cadeaux || Gift cards"],
    ["Jouets","Jouets || Toys"],
    ["Maman et papa","Maman et papa || Mom and dad"],
    ["Meubles","Meubles || Furniture"],
    ["Nulls Gift Product","Nulls Gift Product || Nulls Gift Product"],
    ["PYJAMA","Pyjamas || Pajamas"],
    ["Mitaines et chaussons d'intérieur","Mitaines et chaussons d'intérieur || Mittens and indoor slippers"],
    ["Chaussures","Chaussures || Shoes"],
    ["Produits bain et corps","Produits bain et corps || Bath and body products"],
    ["Vêtements d'extérieur","Vêtements d'extérieur || Outerwear"]
  ];

  klevu.coreEvent.build({
    name: "setRemoteConfigLandingOverride",
    fire: function () {
      if (
        klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build") ||
        klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")  ||
        klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build")
      ) {
        if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build")) {
          window.pageType = "landing";
          window.setRemoteConfig = "setRemoteConfigLanding";
        }
        if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
          window.pageType = "catnav";
          window.setRemoteConfig = "setRemoteConfigCatnav";
        }
        if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build")) {
          window.pageType = "landing";
          window.setRemoteConfig = "setRemoteConfigQuick";
        }
        return true;
      }
      return false;
    },
    maxCount: 150,
    delay: 100
  });

  klevu.coreEvent.attach("setRemoteConfigLandingOverride", {
    name: "attachRemoteConfigLandingOverride",
    fire: function () {

      try {
        // Attach to the Klevu query request chain
        klevu.search[window.pageType]
          .getScope()
          .chains.request.control.addAfter("initRequest", {
          name: "modifyLandingQuery",
          fire: function (data, scope) {
            klevu.each(data.request.current.recordQueries, function (
              key,
              query
            ) {
              query.filters.filtersToReturn.options.limit = 50;
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
      

      // This function call allows the custom filters template to override the default.
      // This is necessary since the sorting will only work within our custom template.
      klevu.search[window.pageType]
        .getScope()
        .template.setTemplate(
        klevu.dom.helpers.getHTML("#klevuLandingTemplateFiltersCustom"),
        "filters",
        true
      );
      klevu.search[window.pageType]
        .getScope()
        .template.setTemplate(
        klevu.dom.helpers.getHTML("#myCustom_searchResultProduct"),
        "productBlock",
        true
      );
      
      // Firefox fix undefined quick
      let interval = null;
      let i = 0;
      
      const executeQuick = function () {
        klevu.search.quick
          .getScope()
          .template.setTemplate(
          klevu.dom.helpers.getHTML("#klevuQuickProductBlockCustom"),
          "klevuQuickProductBlock",
          true
        );
        clearInterval(interval)       
      }

      const checkQuickStatus = function() {
        i++;
        if (window.klevu.search.quick) {
          executeQuick();
        } else if (i >= 50) {
          clearInterval(interval);
        }        
      }

      interval = setInterval(checkQuickStatus, 10);

      // Here is helper function that performs the sorting that we use within the size filter
      // This is helper function is necessary since it is called from the custom template
      try {
        klevu.search[window.pageType]
          .getScope()
          .template.setHelper("orderSizeFacet", function orderSizeFacet(options) {
          // Here we use the order of sizes within this array to control how the sorting is ordered.
          // Customize this array how you would like.
          const sizeOrder = [
            "NN-3 m",
            "0-3 m",
            "0-6 m",
            "3-6 m",
            "6-9 m",
            "6-12 m",
            "9-12 m",
            "12-18 m",
            "12-24 m",
            "2-3 a||2-3 y",
            "2-3 a|| 2-3 y",
            "2-3 a || 2-3 y",
            "2-3 a ||2-3 y",
            "2-3 a||2-3y",
            "18-24 m",
            "18 m - 3 a || 18 m - 3 y",
            "24-3",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "2-3",
            "3-4",
            "4-5",
            "5-6",
            "6-7",
            "7-8",
            "8-10",
            "9-12 m",
            "10-12",
            "11-12",
            "12-18 m",
            "18-24 m",
            "Unique || OS",
            "Nouveau né || Newborn",
            "Très petit || X-Small",
            "Très petit-Petit || X-Small to Small",
            "Petit || Small",
            "Petit-Moyen || Small to Med",
            "Moyen || Medium",
            "Moyen-Grand || Med to Large",
            "Grand || Large",
            "Très grand || X-Large"
          ];
          const alphabetical = options.filter((value) => {
            return value.name;
          });

          sizeOrder.reverse().forEach(function (elem) {
            alphabetical.sort(function (a, b) {
              if (
                b.name.toLowerCase() !== elem.toLowerCase() &&
                a.name.toLowerCase() !== elem.toLowerCase()
              ) {
                return 0;
              } else if (a.name.toLowerCase() === elem.toLowerCase()) {
                return -1;
              } else {
                return 1;
              }
            });
          });
          const orderedOptions = alphabetical;

          return orderedOptions;
        });
      } catch (error) {
        console.log(error);
      }

      try {
        klevu.search[window.pageType]
          .getScope()
          .template.setHelper("orderTypeFacet", function orderTagsFacet(options) {


          const alphabetical = options.filter((value) => {
            return value.name;
          });

          typeOrder.reverse().forEach(function (elem) {
            let i = 0;
            alphabetical.forEach(function (filter) {
              if(elem[0] === filter.name){
                alphabetical[i].name = elem[1];
              }
              i++;
            });
          });

          const orderedOptions = alphabetical;
          return orderedOptions;
        });
      } catch (error) {
        console.log(error);
      }

      // We're done with our overrides, tell Klevu to power up!
      if (window.pageType === "landing") {
        klevu({ powerUp: { landing: true, quick: true } });
      }
      if (window.pageType === "catnav") {
        klevu({ powerUp: { catnav: true } });
      }
    }
  });


  let currentLang = document.querySelector('.language-selector-container .language-selector.hide').dataset.lang;
  let LangIndex = (currentLang == "fr") ? 0 : 1;
  let products = "";

  /**
   * Initial translation
   */
  if (window.pageType === "landing") {
    waitForElement(".kuResultWrap", 4000).then(function() {
      KlevuSearchFilterToFix();
    }).catch(e => {
      return e;
    });
  }

  /**
   * Observe search changes
   */

  klevu.coreEvent.build({
    name: "myQuickSearchOverride",
    fire: function () {
      if (klevu.getGlobalSetting("flags.setRemoteConfigQuick.build", false)) {
        return true;
      }
      return false;
    },
    maxCount: 150,
    delay: 100
  });

  klevu.coreEvent.attach("myQuickSearchOverride", {
    name: "attachToMyQuickSearchOverridee",
    fire: function () {
      klevu.search.quick.getScope().chains.request.control.addAfter("initRequest", {
        name: "modifyQuickQuery",
        fire: function (data, scope) {
          KlevuSearchToFix();
        }
      });
      klevu({
        powerUp: {
          quick: true
        }
      });
    }
  });


  klevu.search.landing.getScope().chains.template.events.add({
    name: "renderResponseCustom",
    fire: function(data, scope) {
      KlevuSearchFilterToFix();
    }
  });

  document.querySelector('html').addEventListener('languageChanged', function() {
    KlevuSearchFilterToFix();
  });

  /**
   * Validate if elements is loaded
   */
  function waitForElement(querySelector, timeout = 0) {
    const startTime = new Date().getTime();
    return new Promise((resolve, reject)=>{
      const timer = setInterval(()=>{
        const now = new Date().getTime();

        if(document.querySelector(querySelector)){
          clearInterval(timer);
          resolve();
        }else if(timeout && now - startTime >= timeout){
          clearInterval(timer);
          reject();
        }
      }, 300);
    });
  }

  /**
   * Fix quick search
   */

  function KlevuSearchToFix() {
    setTimeout(function() {
      const suggestions = document.querySelector('.klevuSuggestionsBlock');

      if(document.querySelector('.klevuProductsViewAll')) {
        let seeAll = document.querySelector('.klevuProductsViewAll');
        suggestions.append(seeAll);

        const seeAllText = document.querySelector('.klevuProductsViewAll a');
        seeAllText.textContent = 'Voir tout || See all';
        fixKlevuTranslation(seeAllText);
      }

      if(document.querySelector('.klevuAutosuggestions .klevuHeadingText')){
        const suggestionHeader = document.querySelector('.klevuAutosuggestions .klevuHeadingText');
        suggestionHeader.textContent = 'Suggestions populaires || Popular suggestions';
        fixKlevuTranslation(suggestionHeader);
      }

      if(document.querySelector('.klevuResultsBlock .klevuHeadingText')){
        const resultHeader = document.querySelector('.klevuResultsBlock .klevuHeadingText');
        resultHeader.textContent = 'Produits || Products';
        fixKlevuTranslation(resultHeader);
      }

      const productsContainer = document.querySelector('.kuQuickResultsListContainer');
      products = productsContainer ?
       productsContainer.querySelectorAll('.klevuProduct') :
       [];

      for (product of products) {
        fixKlevuTranslation(product.querySelector('.klevuQuickProductName'));
      }
    },500);
  }

  if(document.querySelector('body').classList.contains('template-product') || document.querySelector('body').classList.contains('template-cart')) {
    waitForElement(".kuRECSResults", 4000).then(function() {
      KlevuProductRecommendationToFix();
    }).catch(e => {
      return e;
    });

    document.querySelector('html').addEventListener('languageChanged', function() {
      KlevuProductRecommendationToFix();
    });
  }

  /**
   *  Fix recommendations
   */
  function KlevuProductRecommendationToFix() {
    const recomentationContainers = document.querySelectorAll('.klevuWrap');
    for (recomentationContainer of recomentationContainers) {
      products = recomentationContainer.querySelectorAll('.kuRECSItem');
      fixKlevuTranslation(recomentationContainer.querySelector('.kuRECSTitle span'));
      for (product of products) {
        fixKlevuTranslation(product.querySelector('.kuRECSTitle'));
      }
    }
  }

  /**
   * fix search result Page
   */

  function KlevuSearchFilterToFix() {
    const productsContainer = document.querySelector('.kuResults');
    if (productsContainer) {
      const products = productsContainer.querySelectorAll('.klevuProduct');

      for (product of products) {
        fixKlevuTranslation(product.querySelector('.kuName a'));
      }
    }

    const filters = document.querySelectorAll('.klevuFilter li');
    for (filter of filters) {
      fixKlevuTranslation(filter.querySelector('.kufacet-text'));
    }

    const filtersTitle = document.querySelectorAll('.kuFilterBox');
    for (filterTitle of filtersTitle) {
      fixKlevuTranslation(filterTitle.querySelector('.kuFilterHead'));
    }

    const filtersTagValue = document.querySelectorAll('.kuFilterTagValue');
    typeOrder.forEach(function (elem) {
      let i = 0;

      for (filterTagValue of filtersTagValue) {
        if(filterTagValue.querySelector('span')) {
          filterTagValue.querySelector('span').remove();
        }
        if(elem[0].toLowerCase() === filterTagValue.innerText.toLowerCase()){
          filterTagValue.textContent = elem[1];
        }
        i++;
      }
    });

    for (filterTagValue of filtersTagValue) {
      fixKlevuTranslation(filterTagValue);
    }

    //move active filter
    if(document.querySelector('.kuFilterTagsContainer')){
      let filterContainer = document.querySelector('.kuFilterTagsContainer');
      let leftContainer = document.querySelector('[data-container-id="ku_landing_main_content_left"]');
      leftContainer.prepend(filterContainer);
    }

    //move pagination
    if(document.querySelector('.kuPagination')){
      let pagination = document.querySelector('.kuPagination');
      let searchContainer = document.querySelector('[data-container-id="ku_landing_main_content_center"]');
      searchContainer.append(pagination);
    }

    const revelance = document.querySelector('[data-value="RELEVANCE"]');
    if (revelance) {
      revelance.textContent = 'Pertinence || Relevance';
      fixKlevuTranslation(revelance);  
    }

    const price_asc = document.querySelector('[data-value="PRICE_ASC"]');
    if (price_asc) {
      price_asc.textContent = 'Prix croissant || Price: Low to High';
      fixKlevuTranslation(price_asc);  
    }

    const price_desc = document.querySelector('[data-value="PRICE_DESC"]');
    if (price_desc) {
      price_desc.textContent = 'Prix: haut à faible || Price: High to Low';
      fixKlevuTranslation(price_desc);  
    }

    const sortLabel = document.querySelector('.kuDropSortBy .kuDropdownLabel');
    if (sortLabel) {
      if (sortLabel.innerText.includes('Pertinence')) {
        sortLabel.textContent = revelance.textContent;
      }else if (sortLabel.innerText.includes('Croissant')) {
        sortLabel.textContent = price_asc.textContent
      }else if (sortLabel.innerText.includes('Faible')) {
        sortLabel.textContent = price_desc.textContent
      }
      fixKlevuTranslation(sortLabel);  
    }

    if(document.querySelector('.kuResultsHeadingTitleContainer')) {
      const result_count = document.querySelector('.kuResultsHeadingTitleContainer strong').innerHTML;
      let result_search = "";

      if(document.querySelector('.kuResultsHeadingTitleContainer span')){
        result_search = document.querySelector('.kuResultsHeadingTitleContainer span').innerHTML;
      }

      document.querySelector('.kuResultsHeadingTitleContainer').innerHTML = `<strong>${result_count}</strong><p class="search-text">résultats pour || Results found for</p><span>${result_search}</span>`
      fixKlevuTranslation(document.querySelector('.kuResultsHeadingTitleContainer .search-text'));
    }

  };

  /**
   * Update translation
   */
  const fixKlevuTranslation = function(content) {
    if (content) {
      const pattern = "||";
      let string = content.innerText;
      currentLang = document.querySelector('.language-selector-container .language-selector.hide').dataset.lang;
      LangIndex = (currentLang == "fr") ? 0 : 1;
  
      if (string.includes(pattern)) {
        content.dataset.completeTitle = content.innerText;
      }
  
      if (content.dataset.completeTitle) {
        content.textContent = content.dataset.completeTitle.split(pattern)[LangIndex];
        if (content.hasAttribute('alt')) {
          content.alt = content.dataset.completeTitle.split(pattern)[LangIndex];
        }
  
        if (content.hasAttribute('title')) {
          content.title = content.dataset.completeTitle.split(pattern)[LangIndex];
        }
      }
    }
  }
});